'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'beer-mug-empty';
var width = 512;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M368 48l0 48 0 16 0 352L48 464 48 48l320 0zm16 307.8L384 112l112 0 0 194.8-112 49zM384 464l0-90.8 123.2-53.9 4.8-2.1 0-5.2 0-208 0-8-8 0L384 96l0-48 0-16-16 0L48 32 32 32l0 16 0 416 0 16 16 0 320 0 16 0 0-16zM144 136l0-8-16 0 0 8 0 240 0 8 16 0 0-8 0-240zm72 0l0-8-16 0 0 8 0 240 0 8 16 0 0-8 0-240zm72 0l0-8-16 0 0 8 0 240 0 8 16 0 0-8 0-240z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;